import { render, staticRenderFns } from "./DefaultEditor.vue?vue&type=template&id=aa5fc72a&scoped=true"
import script from "./DefaultEditor.vue?vue&type=script&lang=js"
export * from "./DefaultEditor.vue?vue&type=script&lang=js"
import style0 from "./DefaultEditor.vue?vue&type=style&index=0&id=aa5fc72a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5fc72a",
  null
  
)

export default component.exports